import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '../../../../api';
import { preloaderStore } from '../../../preloaderStore';
import { counterpartiesStore } from '../counterpartiesStore';
import type { CmApi, CompanyDto } from '../../../../api';

class CounterpartyEditStore {
  counterparty: CompanyDto | null = null;

  api: CmApi;

  isNew = false;

  editMode = false;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  save = async (company: CompanyDto) => {
    preloaderStore.preloader();
    const { data } = await (this.isNew
      ? this.api.companies.addCompany(company)
      : this.api.companies.updateCompany(company));

    if (data) {
      counterpartiesStore.setIsChanged(true);

      if (this.isNew) {
        preloaderStore.preloader(false);
        return data;
      }
      runInAction(() => {
        this.counterparty = data;
        this.setEditMode(false);
      });
    }
    preloaderStore.preloader(false);
    return undefined;
  };

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };

  delete = async () => {
    if (this.counterparty) {
      await this.api.companies.deleteCompany(this.counterparty);
      counterpartiesStore.setIsChanged(true);
    }
  };

  fetch = async (code: string, counterpartyTypeCode: string, orgLocal?: string): Promise<undefined | CompanyDto> => {
    preloaderStore.preloader(true);
    if (!code || !counterpartyTypeCode) {
      preloaderStore.preloader(false);
      return;
    }
    runInAction(() => {
      this.setEditMode(false);
      this.setNew(false);
    });

    const query: { code: string; counterpartyTypeCode: string; orgLocal?: string } = { code, counterpartyTypeCode };

    if (orgLocal) query.orgLocal = orgLocal;

    const { data } = await this.api.companies.getCompanyCardByCodes(query);

    runInAction(() => {
      this.counterparty = data;
    });
    preloaderStore.preloader(false);
    return data;
  };

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.counterparty = null;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  get isEditMode() {
    return this.editMode || this.isNew;
  }
}

export const counterpartyEditStore = new CounterpartyEditStore({ api: cmApi });
